import React from "react"

import styles from "./BudgetSummary.module.css"

import Select from "~/common/Select"
import SimpleLabel from "~/common/labels/SimpleLabel"

import { BudgetMethod } from "../types"

export const BUDGET_METHODS: {
  value: BudgetMethod
  label: string | JSX.Element
}[] = [
  { value: "ROLE", label: "Roles" },
  {
    value: "PHASE",
    label: (
      <>
        Phases{" "}
        <SimpleLabel text="Beta" type="beta" className={styles.betaLabel} />
      </>
    ),
  },
  {
    value: "PHASE_AND_ROLE",
    label: (
      <>
        Phases &amp; Roles{" "}
        <SimpleLabel text="Beta" type="beta" className={styles.betaLabel} />
      </>
    ),
  },
]

type Props = {
  onChange: (e: any) => void
  value: (typeof BUDGET_METHODS)[number]["value"]
  label?: string
  className?: string
}

const BudgetMethodSelector = (props: Props) => {
  const { onChange, value, label, className } = props

  const budgetMethod = BUDGET_METHODS.find((method) => method.value === value)

  return (
    <Select
      name="project-budget-method"
      id="project-budget-method"
      dataTest="project-budget-method"
      value={budgetMethod}
      onChange={(e) => onChange(e.value)}
      options={BUDGET_METHODS}
      height={40}
      fontSize={13}
      doNotSortOptions
      label={label}
      className={className}
    />
  )
}

export default BudgetMethodSelector
